export function isValidAttendanceCode(code: unknown): code is string {
  return (
    typeof code === "string" && code.length === 6 && /^[0-9]{6}$/.test(code)
  )
}
